module.exports = __webpack_public_path__ + "static/media/starter-mr-card-back.4145f92f.jpeg";